import React, { useState } from 'react'
import { Body } from 'components/Shell/Shell'
import { RadioInput } from 'components/Wizard2/fieldComponents/Form'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import FormCard from 'components/FormCard/FormCard'
import { GET_UID_CORP, GET_UID_INDIVIDUAL } from '../../requests'

const UinGeneration = () => {
  const [uinType, setUinType] = useState('GetUinFromFullName')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [fienNumber, setFienNumber] = useState('')
  const [uinValue, setUinValue] = useState(null)

  const submit = () => {
    if (!fienNumber || fienNumber.length != 4) {
      return
    }

    setUinValue('Loading . . .')

    if (uinType == 'GetUinFromFullName') {
      if (!firstName || !lastName) {
        return
      }

      GET_UID_INDIVIDUAL(
        firstName.replace(/[^a-zA-Z0-9]/g, '='),
        lastName.replace(/[^a-zA-Z0-9]/g, '='),
        fienNumber,
        (result) => {
          setUinValue(result.Uin)
        },
        (error) => {
          console.error(error)
          setUinValue(error.error)
        }
      )
    } else {
      GET_UID_CORP(
        companyName.replace(/[^a-zA-Z0-9]/g, '='),
        fienNumber,
        (result) => {
          setUinValue(result.Uin)
        },
        (error) => {
          console.error(error)
          setUinValue(error.error)
        }
      )
    }
  }

  const GetButtonEnabled = () => {
    if (uinType == 'GetUinFromFullName') {
      return !(fienNumber.length == 4 && firstName.length > 0 && lastName.length > 0)
    } else {
      return !(fienNumber.length == 4 && companyName.length > 0)
    }
  }

  return (
    <Body className="flex-center-page verify-certificate">
      <FormCard
        seal
        title={'EFS Unique Identifier Number Request'}
        leftColumn={
          <React.Fragment>
            <div style={{ paddingBottom: '1.75em' }}>
              <RadioInput
                value={uinType}
                onChange={(value) => {
                  setUinType(value)
                }}
                options={[
                  { value: 'GetUinFromFullName', label: 'Individual' },
                  { value: 'GetUinFromCompanyName', label: 'Corporation' },
                ]}
                label="Debtor Type"
                ownsLabel
              />
            </div>
            {uinType == 'GetUinFromFullName' && (
              <div>
                <TextInput
                  label="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />

                <TextInput
                  label="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            )}

            {uinType == 'GetUinFromCompanyName' && (
              <div>
                <TextInput
                  label="Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>
            )}

            <div style={{ paddingBottom: '1.75em', paddingTop: '1.75em' }}>
              <TextInput
                label="Last 4 digits of SSN or FIEN number"
                value={fienNumber}
                onChange={(e) => {
                  setFienNumber(
                    e.target.value.length <= 4 ? e.target.value.replace(/\D/g, '') : fienNumber
                  )
                }}
              />
            </div>

            <button
              className="btn btn-primary btn-raised"
              disabled={GetButtonEnabled()}
              onClick={submit}
            >
              Submit
            </button>
          </React.Fragment>
        }
        rightColumn={
          <div className="description">
            <h2>EFS Unique Identifier Number Request</h2>
            <p>
              To request a Unique Identifier Number, please enter the required information in the
              fields below and click 'Submit'. The result will appear below.
            </p>
            <p style={{ fontSize: '2em' }}>
              {' '}
              <b>Generated UIN :</b> {uinValue}{' '}
            </p>
          </div>
        }
      />
    </Body>
  )
}

export default UinGeneration
